import React, { useCallback } from 'react'
import { addListItems, changeListItem, deleteListItem, getFormValue, getListItems, getListValuesFromList } from 'tyan/public/utility'
import { useInstData, useEventHandler } from 'tyan/public/hooks'

const sortField = '_sort'
const ExportColumns = props => {
	const { showBody: Body, defaults, selected, total, onExport, onClose } = props

	const { me, me: { state: {
		_gridSelectedValuesBasic: {
			selectedCols: _selectedCols, unselectedCols: _unselectedCols
		}
	} } } = useInstData(props, () => {
		// 转换descs为list数据
		const { descs } = props
		const selectedCols = getListValuesFromList('selectedCols', descs.map((text, i) => ({ id: i + 1, text, [sortField]: i + 1 })))
		return {
			state: {
				initValuesBasic: { data: selected && selected != total ? 'selected' : 'all', ...selectedCols },
				changedValuesBasic: {},
				_gridSelectedValuesBasic: {}
				// selectedCols, unselectedCols
			}
		}
	})


	const dataItems = [[`${Tyan.t('全部')} ${total} ${Tyan.t('条记录')}`, 'all']]
	selected && selected != total && dataItems.unshift([`${Tyan.t('已选择')} ${selected} ${Tyan.t('条记录')}`, 'selected'])

	const { list } = getListItems(me, 'Basic', 'selectedCols', undefined, sortField)
	const minSort = list[0]?.[sortField] || 1
	const maxSort = list[list.length - 1]?.[sortField] || 1

	const choiced = list.map(({ text }) => text)

	const data = getFormValue(me, 'Basic', 'data')
	const canExport = choiced.length && data

	const handleExport = useEventHandler(() => {
		if (!choiced.length || !data)
			return

		onExport(choiced, data)
	})

	const doSelect = datas => {
		addListItems(me, datas, 'Basic', 'selectedCols', sortField)
		deleteListItem(me, 'Basic', 'unselectedCols', datas.map(({ id }) => id))
	}

	const handleSelect = useCallback(() => {
		const { state: { _gridSelectedValuesBasic: { unselectedCols = [] } } } = me
		doSelect(unselectedCols.map(({ data }) => data))
	}, [])

	// 未选项双击
	const handleDoubleTapUnselected = useCallback(data => {
		doSelect([data])
	}, [])

	const doDeselect = datas => {
		addListItems(me, datas, 'Basic', 'unselectedCols', sortField)
		deleteListItem(me, 'Basic', 'selectedCols', datas.map(({ id }) => id))
	}

	const handleDeselect = useCallback(() => {
		const { state: { _gridSelectedValuesBasic: { selectedCols = [] } } } = me
		doDeselect(selectedCols.map(({ data }) => data))
	}, [])

	// 已选项双击
	const handleDoubleTapSelected = useCallback(data => {
		doDeselect([data])
	}, [])

	const doSort = (direction, toChange) => {
		const { list } = getListItems(me, 'Basic', 'selectedCols', undefined, sortField)
		const index = list.findIndex(({ id }) => id == toChange)

		if (direction === 'up' ? index < 0 : index >= list.length - 1) return

		const newList = list.slice(...direction === 'up' ? [index - 1, index + 1] : [index, index + 2])
		const ids = newList.map(({ id }) => id)
		const values = newList.map(({ [sortField]: sort }) => ({ [sortField]: sort })).reverse()

		changeListItem(me, values, undefined, 'Basic', 'selectedCols', ids, newList)
	}

	const handleSortUp = (that, { id: toChange }) => {
		doSort('up', toChange)
	}

	const handleSortDown = (that, { id: toChange }) => {
		doSort('down', toChange)
	}

	return <Body data={me} maxWidth="1200"
		controls={
			[
				{ _button: '确定', /* icon: 'download', */ handler: handleExport, disabled: !canExport },
				{ _button: '取消', /* icon: 'close',  */handler: onClose },
			]}
		fieldsets={
			[
				{
					title: '', name: 'Basic', _fieldset: [
						{ _radio: '数据', itemNoLocale: true, required: true, name: 'data', items: dataItems, minWidth: '90%' },
						// { _checkbox: '字段', required: true, name: 'descs', items: descs },
						{
							_grid: '', name: 'unselectedCols', maxWidth: 500, rowNumbers: false, minRows: 15, margin: "0px 0px 5px 10px", height: '100%',
							multiSelect: true, onDoubleTap: handleDoubleTapUnselected,
							columns: [
								{ _text: '未选字段', name: 'text', minWidth: 150, flex: 1, },
							],
						},
						{
							_buttons: [
								{ _button: '>>', handler: handleSelect, disabled: !_unselectedCols?.length, margin: '5px 0px 5px 0px', },
								{ _button: '<<', handler: handleDeselect, disabled: !_selectedCols?.length, margin: '5px 0px 5px 0px', },
							], width: '50', margin: '200px 0px 5px 0px', layout: { type: 'vbox', pack: 'start', align: 'center' },
						},
						{
							_grid: '', name: 'selectedCols', maxWidth: 500, rowNumbers: false, minRows: 15, margin: "0px 0px 5px 0px", height: '100%',
							sort: sortField, multiSelect: true, onDoubleTap: handleDoubleTapSelected,
							columns: [
								{
									_text: '已选字段', name: 'text', minWidth: 150, flex: 1, tools: [
										{
											_tool: '向上', ui: 'action', iconCls: 'x-fa fa-angle-up', zone: 'end',
											disabled: ({ [sortField]: sort }) => sort == minSort,
											handler: handleSortUp,
										},
										{
											_tool: '向下', ui: 'action', iconCls: 'x-fa fa-angle-down', zone: 'end',
											disabled: ({ [sortField]: sort }) => sort == maxSort,
											handler: handleSortDown,
										},
									]
								},
							],
						},
					]
				},
			]}
	/>
}

export default ExportColumns